<template>

  <a-form-model
      ref="targetForm"
      :model="form"
      :rules="rules"
      :label-col="{span: 12}"
      :wrapper-col="{span: 12}"
  >
    <a-alert message="温馨提示：请注意您填写的信息仅适用于签证申请，请如实提供真实信息。" banner closable/>
    <a-card title="个人信息">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否有曾有名" prop="otherName">
            <a-radio-group v-model="form.otherName">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.otherName === 'Yes'">
          <a-form-model-item label="姓氏(曾有名)" prop="otherSurname">
            <a-input placeholder="例如 li" v-model="form.otherSurname"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.otherName === 'Yes'">
          <a-form-model-item label="名字(曾有名)" prop="otherGivenName">
            <a-input placeholder="例如 xinan" v-model="form.otherGivenName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="性别" prop="sex">
            <a-radio-group v-model="form.sex">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照出生地" prop="placeOfBirth">
            <a-input placeholder="例如 广州" v-model="form.placeOfBirth"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生日期" prop="birthday">
            <a-date-picker style="width: 100%" v-model="form.birthday" :disabled-date="afterNow"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="手机号" prop="telephone">
            <a-input placeholder="例如 13543000000" v-model="form.telephone"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="婚姻状况" prop="relationshipStatus">
            <a-select v-model="form.relationshipStatus" placeholder="请选择">
              <a-select-option value="S">单身</a-select-option>
              <a-select-option value="M">已婚/同性伴侣</a-select-option>
              <a-select-option value="U">未婚伴侣</a-select-option>
              <a-select-option value="D">离婚/同性伴侣关系解除</a-select-option>
              <a-select-option value="P">分居</a-select-option>
              <a-select-option value="W">丧偶/尚存同性伴侣</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现居地址省份" prop="homeAddressForProvince">
            <a-input placeholder="例如 广东" v-model="form.homeAddressForProvince"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现居地址城市" prop="homeAddressForCity">
            <a-input placeholder="例如 广州" v-model="form.homeAddressForCity"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现居详细地址" prop="homeAddressForStreet">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.homeAddressForStreet"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现居地址时长(年)" prop="timeLived">
            <a-input-number style="width: 100%" v-model="form.timeLived" :min="1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="房产权归属" prop="propertyRight">
            <a-select v-model="form.propertyRight" placeholder="请选择">
              <a-select-option value="ownershipCategory_own">自己购买</a-select-option>
              <a-select-option value="ownershipCategory_rent">租用</a-select-option>
              <a-select-option value="ownershipCategory_other">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.propertyRight ==='ownershipCategory_other'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="居住说明" prop="otherCategoryDetails">
            <a-input placeholder="房产权归属属于其他说明" v-model="form.otherCategoryDetails"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="parseInt(form.timeLived) === 1">

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾住省份(2年以上)" prop="homeAddressForProvinced">
            <a-input placeholder="例如 广东" v-model="form.homeAddressForProvinced"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾住城市(2年以上)" prop="homeAddressForCityd">
            <a-input placeholder="例如 广州" v-model="form.homeAddressForCityd"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾住详细地址(2年以上)" prop="homeAddressForStreetd">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.homeAddressForStreetd"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾住地址时间" prop="dateForRent">
            <a-range-picker style="width: 100%" v-model="form.dateForRent" :placeholder="['开始', '结束']"
                            value-format="YYYY-MM-DD" :inputReadOnly="true"
                            :disabled-date="timeInRent"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="证件信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否有身份证" prop="hasNationalIdCard">
            <a-radio-group v-model="form.hasNationalIdCard">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.hasNationalIdCard && form.hasNationalIdCard === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="身份证号" prop="nationalIdCard">
            <a-input placeholder="例如 440000000000000000" v-model="form.nationalIdCard"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="身份证签发地" prop="issuingAuthorityForIdCard">
            <a-input placeholder="例如 广州" v-model="form.issuingAuthorityForIdCard"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="身份证有效期" prop="startDateForIdCardNo">
            <a-date-picker style="width: 100%" v-model="form.startDateForIdCardNo" placeholder="开始"
                           value-format="YYYY-MM-DD" :disabled-date="afterNow"/>

          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="身份证有效期" prop="endDateForIdCardNo">
            <a-date-picker style="width: 100%" v-model="form.endDateForIdCardNo" placeholder="结束(长期可不填)"
                           value-format="YYYY-MM-DD" :disabled-date="beforeNow"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照签发地" prop="issuingAuthorityForPassport">
            <a-input placeholder="例如 广州" v-model="form.issuingAuthorityForPassport"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照有效期" prop="startDateForPassport">
            <a-date-picker style="width: 100%" v-model="form.startDateForPassport" placeholder="开始"
                           value-format="YYYY-MM-DD" :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照有效期" prop="endDateForPassport">
            <a-date-picker style="width: 100%" v-model="form.endDateForPassport" placeholder="结束"
                           value-format="YYYY-MM-DD" :disabled-date="beforeNow"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="家庭信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="父亲姓氏(拼音)" prop="fatherSurnames">
            <a-input v-model="form.fatherSurnames" placeholder="例如 zhang"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="父亲名字(拼音)" prop="fatherGivenNames">
            <a-input v-model="form.fatherGivenNames" placeholder="例如 san"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="父亲出生日期" prop="fatherDateOfBirth">
            <a-date-picker style="width: 100%" v-model="form.fatherDateOfBirth" placeholder="请选择"
                           value-format="YYYY-MM-DD"
                           :disabled-date="afterBirthday"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否同行" prop="travelWithFather"
                             v-if="form.birthday && (moment().diff(form.birthday, 'year', false)) < 13">
            <a-radio-group v-model="form.travelWithFather">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.travelWithFather && form.travelWithFather === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="手机号" prop="fatherTelephone">
            <a-input placeholder="例如 13543000000" v-model="form.fatherTelephone"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮箱" prop="fatherEmail">
            <a-input v-model="form.fatherEmail" placeholder="例如 visitorinfo@stanford.edu"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照" prop="fatherPassport">
            <a-input placeholder="例如 EB8195***" v-model="form.fatherPassport"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="母亲姓氏(拼音)" prop="motherSurnames">
            <a-input v-model="form.motherSurnames" placeholder="例如 li"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="母亲名字(拼音)" prop="motherGivenNames">
            <a-input v-model="form.motherGivenNames" placeholder="例如 si"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="母亲出生日期" prop="motherDateOfBirth">
            <a-date-picker style="width: 100%" v-model="form.motherDateOfBirth" placeholder="请选择"
                           value-format="YYYY-MM-DD"
                           :disabled-date="afterBirthday"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否同行" prop="travelWithMother"
                             v-if="form.birthday && (moment().diff(form.birthday, 'year', false)) < 13">
            <a-radio-group v-model="form.travelWithMother">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.travelWithMother && form.travelWithMother === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="手机号" prop="motherTelephone">
            <a-input placeholder="例如 13543000000" v-model="form.motherTelephone"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮箱" prop="motherEmail">
            <a-input v-model="form.motherEmail" placeholder="例如 visitorinfo@stanford.edu"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照" prop="motherPassport">
            <a-input placeholder="例如 EB8195***" v-model="form.motherPassport"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.relationshipStatus === 'M'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶姓氏(拼音)" prop="spouseSurnames">
            <a-input v-model="form.spouseSurnames" placeholder="例如 li"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶名字(拼音)" prop="spouseGivenNames">
            <a-input v-model="form.spouseGivenNames" placeholder="例如 si"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="配偶出生日期" prop="spouseDateOfBirth">
            <a-date-picker style="width: 100%" v-model="form.spouseDateOfBirth" placeholder="请选择"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否同行" prop="travelWithPartner">
            <a-radio-group v-model="form.travelWithPartner">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.travelWithPartner === 'Yes'">
          <a-form-model-item label="伴侣护照" prop="partnerPassport">
            <a-input placeholder="例如 EB8195***" v-model="form.partnerPassport"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.relationshipStatus === 'M'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="有子女需要抚养" prop="son">
            <a-radio-group v-model="form.son">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.relationshipStatus === 'M' && form.son === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="子女姓氏1(拼音)" prop="sonSurnames1">
            <a-input v-model="form.sonSurnames1" placeholder="例如 li"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="子女名字1(拼音)" prop="sonGivenNames1">
            <a-input v-model="form.sonGivenNames1" placeholder="例如 li"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="子女出生日期1" prop="sonDateOfBirth1">
            <a-date-picker style="width: 100%" v-model="form.sonDateOfBirth1" placeholder="请选择"
                           value-format="YYYY-MM-DD"
                           :disabled-date="beforeBirthday"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="关系" prop="sonRelationShip1">
            <a-select placeholder="请选择" v-model="form.sonRelationShip1">
              <template v-if="form.sex === 'Male'">
                <a-select-option value="Father and son">父子</a-select-option>
                <a-select-option value="Father and daughter">父女</a-select-option>
              </template>
              <template v-if="form.sex === 'Female'">
                <a-select-option value="Mother and son">母子</a-select-option>
                <a-select-option value="Mother and daughter">母女</a-select-option>
              </template>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="旅英同行1" prop="travelWithSon1">
            <a-radio-group v-model="form.travelWithSon1">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.travelWithSon1 === 'Yes'">
          <a-form-model-item label="孩子护照1" prop="sonPassport1">
            <a-input placeholder="例如 EB8195***" v-model="form.sonPassport1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.sonRecord2 || form.sonRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addSonRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.relationshipStatus === 'M' && form.son === 'Yes' && form.sonRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="子女姓氏2(拼音)" prop="sonSurnames2">
            <a-input v-model="form.sonSurnames2" placeholder="例如 li"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="子女名字2(拼音)" prop="sonGivenNames2">
            <a-input v-model="form.sonGivenNames2" placeholder="例如 li"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="子女出生日期2" prop="sonDateOfBirth2">
            <a-date-picker style="width: 100%" v-model="form.sonDateOfBirth2" placeholder="请选择"
                           value-format="YYYY-MM-DD"
                           :disabled-date="beforeBirthday"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="关系" prop="sonRelationShip2">
            <a-select placeholder="请选择" v-model="form.sonRelationShip2">
              <template v-if="form.sex === 'Male'">
                <a-select-option value="Father and son">父子</a-select-option>
                <a-select-option value="Father and daughter">父女</a-select-option>
              </template>
              <template v-if="form.sex === 'Female'">
                <a-select-option value="Mother and son">母子</a-select-option>
                <a-select-option value="Mother and daughter">母女</a-select-option>
              </template>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="旅英同行2" prop="travelWithSon2">
            <a-radio-group v-model="form.travelWithSon2">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.travelWithSon2 === 'Yes'">
          <a-form-model-item label="孩子护照2" prop="sonPassport2">
            <a-input placeholder="例如 EB8195***" v-model="form.sonPassport2"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.sonRecord3 || form.sonRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addSonRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeSonRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.relationshipStatus === 'M' && form.son === 'Yes' && form.sonRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="子女姓氏3(拼音)" prop="sonSurnames3">
            <a-input v-model="form.sonSurnames3" placeholder="例如 li"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="子女名字3(拼音)" prop="sonGivenNames3">
            <a-input v-model="form.sonGivenNames3" placeholder="例如 li"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="子女出生日期3" prop="sonDateOfBirth3">
            <a-date-picker style="width: 100%" v-model="form.sonDateOfBirth3" placeholder="请选择"
                           value-format="YYYY-MM-DD"
                           :disabled-date="beforeBirthday"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="关系" prop="sonRelationShip3">
            <a-select placeholder="请选择" v-model="form.sonRelationShip3">
              <template v-if="form.sex === 'Male'">
                <a-select-option value="Father and son">父子</a-select-option>
                <a-select-option value="Father and daughter">父女</a-select-option>
              </template>
              <template v-if="form.sex === 'Female'">
                <a-select-option value="Mother and son">母子</a-select-option>
                <a-select-option value="Mother and daughter">母女</a-select-option>
              </template>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="旅英同行3" prop="travelWithSon3">
            <a-radio-group v-model="form.travelWithSon3">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.travelWithSon3 === 'Yes'">
          <a-form-model-item label="孩子护照3" prop="sonPassport3">
            <a-input placeholder="例如 EB8195***" v-model="form.sonPassport3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeSonRecord(3)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="工作信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="工作状况" prop="employmentStatus">
            <a-select mode="multiple" placeholder="请选择" v-model="form.employmentStatus">
              <a-select-option value="status_employed">受雇</a-select-option>
              <a-select-option value="status_self-employed">自雇</a-select-option>
              <a-select-option value="status_retired">退休</a-select-option>
              <a-select-option value="status_unemployed">失业</a-select-option>
              <a-select-option value="status_student">学生</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.employmentStatus && form.employmentStatus.includes('status_employed')">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="单位名称" prop="employer">
            <a-input placeholder="例如 腾讯公司" v-model="form.employer"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="单位省份" prop="employerProvince">
            <a-input placeholder="例如 广东" v-model="form.employerProvince"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="单位城市" prop="employerCity">
            <a-input placeholder="例如 广州" v-model="form.employerCity"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="单位地址" prop="employerAddress">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.employerAddress"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="单位电话号" prop="employerPhone">
            <a-input placeholder="例如 07565573000" v-model="form.employerPhone"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.employmentStatus && form.employmentStatus.includes('status_employed')">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="入职日期" prop="startWorkForEmployer">
            <a-date-picker style="width: 100%" v-model="form.startWorkForEmployer" value-format="YYYY-MM-DD"
                           :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="职位" prop="jobTitle">
            <a-input placeholder="例如 CEO" v-model="form.jobTitle"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="税后月收入(£)" prop="jobEarn">
            <a-input-number style="width: 100%" v-model="form.jobEarn" :min="100"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="工作描述" prop="jobDescribe">
            <a-input placeholder="例如 公司方向策略制定" v-model="form.jobDescribe"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.employmentStatus && form.employmentStatus.includes('status_self-employed')">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="自雇职位" prop="selfJobTitle">
            <a-input placeholder="例如 CEO" v-model="form.selfJobTitle"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="自雇年收入(£)" prop="selfJobEarn">
            <a-input-number style="width: 100%" v-model="form.selfJobEarn" :min="100"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="收入和费用" style="margin-top: 24px">
      <template v-if="model.visaType ==='visaType_visit-visa-ooc-standard'">
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="经常性收入" prop="otherIncome">
              <a-radio-group v-model="form.otherIncome">
                <a-radio value="Yes">有</a-radio>
                <a-radio value="No">没</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.otherIncome ==='Yes'">
            <a-form-model-item label="收入来源" prop="regularIncome">
              <a-select mode="multiple" placeholder="请选择" v-model="form.regularIncome">
                <a-select-option value="sourceRefs_allowance">津贴或家庭的经常性款项</a-select-option>
                <a-select-option value="sourceRefs_pension">退休金</a-select-option>
                <a-select-option value="sourceRefs_investments">投资</a-select-option>
                <a-select-option value="sourceRefs_other">其它收入</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.otherIncome ==='Yes'">
            <a-form-model-item label="年收入(£)" prop="incomeAmount">
              <a-input-number style="width: 100%" v-model="form.incomeAmount" :min="100"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="储蓄(需提供证明)" prop="hasSavings">
              <a-radio-group v-model="form.hasSavings">
                <a-radio value="Yes">有</a-radio>
                <a-radio value="No">没</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.hasSavings ==='Yes'">
            <a-form-model-item label="储蓄金额(£)" prop="savingsAmount">
              <a-input-number style="width: 100%" v-model="form.savingsAmount" :min="100"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="每月花销(£)" prop="spend">
              <a-input-number style="width: 100%" v-model="form.spend" :min="100"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="计划访英花费(£)" prop="planSpend">
              <a-input-number style="width: 100%" v-model="form.planSpend" :min="100"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="有他人赞助您访英" prop="payingForYourVisit">
              <a-radio-group v-model="form.payingForYourVisit">
                <a-radio value="Yes">是</a-radio>
                <a-radio value="No">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.payingForYourVisit === 'Yes'">
            <a-form-model-item label="赞助人" prop="costForVisit">
              <a-select placeholder="请选择" v-model="form.costForVisit">
                <a-select-option value="whoIsPayingRef_someoneIKnow">家人或朋友</a-select-option>
                <a-select-option value="whoIsPayingRef_myEmployerOrCompany">雇主或公司</a-select-option>
                <a-select-option value="whoIsPayingRef_otherEmployerOrCompany">其他组织</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row"
               v-if="form.payingForYourVisit === 'Yes' && form.costForVisit === 'whoIsPayingRef_someoneIKnow'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助人姓名" prop="costSomeoneName">
              <a-input placeholder="eg, Harrison" v-model="form.costSomeoneName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助金额(£)" prop="costSomeoneTotal">
              <a-input-number style="width: 100%" v-model="form.costSomeoneTotal" :min="100"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助原因" prop="costSomeoneReason">
              <a-input placeholder="例如 ****" v-model="form.costSomeoneReason"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助人地址省份" prop="costSomeoneAddressForProvince">
              <a-input placeholder="例如 广东" v-model="form.costSomeoneAddressForProvince"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助人地址城市" prop="costSomeoneAddressForCity">
              <a-input placeholder="例如 广州" v-model="form.costSomeoneAddressForCity"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助人详细地址" prop="costSomeoneAddressForStreet">
              <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.costSomeoneAddressForStreet"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row"
               v-if="form.payingForYourVisit === 'Yes' && form.costForVisit === 'whoIsPayingRef_myEmployerOrCompany'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助金额(£)" prop="costCompanyTotal">
              <a-input-number style="width: 100%" v-model="form.costCompanyTotal" :min="100"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助原因" prop="costCompanyReason">
              <a-input placeholder="例如 ****" v-model="form.costCompanyReason"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row"
               v-if="form.payingForYourVisit === 'Yes' && form.costForVisit === 'whoIsPayingRef_otherEmployerOrCompany'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助公司名" prop="costOtherName">
              <a-input placeholder="eg, Apple" v-model="form.costOtherName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助金额(£)" prop="costOtherTotal">
              <a-input-number style="width: 100%" v-model="form.costOtherTotal" :min="100"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助原因" prop="costOtherReason">
              <a-input placeholder="例如 ****" v-model="form.costOtherReason"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助公司地址省份" prop="costOtherAddressForProvince">
              <a-input placeholder="例如 广东" v-model="form.costOtherAddressForProvince"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助公司地址城市" prop="costOtherAddressForCity">
              <a-input placeholder="例如 广州" v-model="form.costOtherAddressForCity"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="赞助公司详细地址" prop="costOtherAddressForStreet">
              <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.costOtherAddressForStreet"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </template>
      <template v-if="model.visaType === 'visaType_student-ooc'">
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="课程费用(£)" prop="courseFees">
              <a-input-number style="width: 100%" placeholder="第一年" v-model="form.courseFees" :min="1"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </template>
    </a-card>
    <a-card title="旅行信息" style="margin-top: 24px">
      <template v-if="model.visaType === 'visaType_visit-visa-ooc-standard'">
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="访英的主要原因" prop="purposeOfVisit">
              <a-select placeholder="请选择" v-model="form.purposeOfVisit">
                <a-select-option value="purposeRef_tourism">旅游(包括探亲访友)</a-select-option>
                <a-select-option value="purposeRef_business">商业(包括体育和娱乐)</a-select-option>
                <a-select-option value="purposeRef_study">短期学习(最长6个月)，包括娱乐课程</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <template
              v-if="form.purposeOfVisit === 'purposeRef_tourism' || form.purposeOfVisit === 'purposeRef_business'">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="访英的主要目的" prop="reasonOfVisit">
                <a-select placeholder="请选择" v-model="form.reasonOfVisit">
                  <template v-if="form.purposeOfVisit === 'purposeRef_business'">
                    <a-select-option value="purposeRef_meeting">参加商务会议</a-select-option>
                    <a-select-option value="purposeRef_research">开展研究或实况调查</a-select-option>
                    <a-select-option value="purposeRef_jobTraining">职业培训</a-select-option>
                    <a-select-option value="purposeRef_lectures">参加讲座/演讲</a-select-option>
                    <a-select-option value="purposeRef_entertainmentEvent">在娱乐活动中演出</a-select-option>
                    <a-select-option value="purposeRef_sportEvent">参加体育活动</a-select-option>
                    <a-select-option value="purposeRef_religious">宗教活动</a-select-option>
                    <a-select-option value="purposeRef_secureFunding">为启动、接管、参与或运行公司或商业项目而募集资金
                    </a-select-option>
                    <a-select-option value="purposeRef_plab">
                      参加专业和语言评估委员会测试(PLAB)或参加宗旨被构造的临床考试
                    </a-select-option>
                    <a-select-option value="purposeRef_clinicalAttachments">临床实践或牙科观察职位</a-select-option>
                    <a-select-option value="purposeRef_ppe">被允许的短期有偿工作</a-select-option>
                    <a-select-option value="purposeRef_other">其它</a-select-option>
                  </template>
                  <template v-if="form.purposeOfVisit === 'purposeRef_tourism'">
                    <a-select-option value="purposeRef_tourist">旅游</a-select-option>
                    <a-select-option value="purposeRef_visitingFamily">拜访家人</a-select-option>
                    <a-select-option value="purposeRef_visitingFriends">拜访朋友</a-select-option>
                  </template>
                </a-select>
              </a-form-model-item>
            </a-col>

          </template>
          <template v-if="form.purposeOfVisit === 'purposeRef_study'">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="学校名称" prop="institutionName">
                <a-input placeholder="例如 剑桥" v-model="form.institutionName"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="课程名称" prop="courseName">
                <a-input placeholder="例如 人工智能" v-model="form.courseName"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="获得学历/证书" prop="courQualification">
                <a-input placeholder="例如 学士学位" v-model="form.courQualification"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="学习时间" prop="dateForCourse">
                <a-range-picker style="width: 100%" v-model="form.dateForCourse" :placeholder="['开始', '结束']"
                                value-format="YYYY-MM-DD" :inputReadOnly="true"
                                :disabled-date="beforeNow"/>
              </a-form-model-item>
            </a-col>
          </template>
        </a-row>
        <a-row class="form-row" v-if="form.purposeOfVisit === 'purposeRef_business'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="商务活动获得报酬" prop="paymentForNonPPEBusinessActivities">
              <a-radio-group v-model="form.paymentForNonPPEBusinessActivities">
                <a-radio value="Yes">是</a-radio>
                <a-radio value="No">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="访问在英的公司" prop="organisationsVisited">
              <a-radio-group v-model="form.organisationsVisited">
                <a-radio value="Yes">是</a-radio>
                <a-radio value="No">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row"
               v-if="form.purposeOfVisit === 'purposeRef_business' && form.organisationsVisited === 'Yes'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英公司名称" prop="englishCompanyName">
              <a-input placeholder="eg, apple" v-model="form.englishCompanyName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英公司业务" prop="englishCompanyWork">
              <a-input placeholder="eg, computer service" v-model="form.englishCompanyWork"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英公司电话" prop="englishCompanyPhone">
              <a-input addon-before="+44" v-model="form.englishCompanyPhone"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英公司地址" prop="englishCompanyAddress">
              <a-input placeholder="" v-model="form.englishCompanyAddress"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英公司城市" prop="englishCompanyCity">
              <a-input placeholder="" v-model="form.englishCompanyCity"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英公司邮编" prop="englishCompanyZipCode">
              <a-input v-model="form.englishCompanyZipCode"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row"
               v-if="form.purposeOfVisit === 'purposeRef_business' && form.organisationsVisited === 'Yes'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英联系人姓" prop="englishCompanyRelativesSurname">
              <a-input v-model="form.englishCompanyRelativesSurname" placeholder="eg, P"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英联系人名字" prop="englishCompanyRelativesGivenName">
              <a-input v-model="form.englishCompanyRelativesGivenName" placeholder="eg, G"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </template>
      <template v-if="model.visaType === 'visaType_student-ooc'">
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="sponsor licence number" prop="sponsorNumber">
              <a-input placeholder="" v-model="form.sponsorNumber"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="CAS number" prop="cas">
              <a-input placeholder="" v-model="form.cas"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="学校名称" prop="schoolName">
              <a-input placeholder="例如 The University of Manchester" v-model="form.schoolName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="学校类型" prop="schoolType">
              <a-select placeholder="请选择" v-model="form.schoolType">
                <a-select-option value="schoolOrHigherEducation_independentSchool">Independent School</a-select-option>
                <a-select-option value="schoolOrHigherEducation_higherEducationProvider">Higher Education Provider
                </a-select-option>
                <a-select-option value="schoolOrHigherEducation_higherEducationProviderCompliance">Higher Education
                  Provider with a track record of compliance
                </a-select-option>
                <a-select-option value="schoolOrHigherEducation_overseasHigherEducationProvider">Overseas Higher
                  Education
                  Provider
                </a-select-option>
                <a-select-option value="schoolOrHigherEducation_publiclyFundedCollege">Publicly Funded College
                </a-select-option>
                <a-select-option value="schoolOrHigherEducation_privateProvider">Private Provider</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="学校所在城市" prop="schoolCity">
              <a-input placeholder="例如 Manchester" v-model="form.schoolCity"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="学校邮编" prop="schoolCityZipCode">
              <a-input placeholder="例如 M13 9PL" v-model="form.schoolCityZipCode"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="课程" prop="course">
              <a-input placeholder="" v-model="form.course"/>
            </a-form-model-item>

          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="课程时间" prop="courseDate">
              <a-range-picker style="width: 100%" v-model="form.courseDate" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']"
                              :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="攻读获取证书" prop="qualification">
              <a-select placeholder="请选择" v-model="form.qualification">
                <a-select-option value="RQF1">RQF1/SCQF4</a-select-option>
                <a-select-option value="RQF2">RQF2/SCQF5</a-select-option>
                <a-select-option value="RQF3">RQF3/SCQF6</a-select-option>
                <a-select-option value="RQF4">RQF4/SCQF7</a-select-option>
                <a-select-option value="RQF5">RQF5/SCQF8</a-select-option>
                <a-select-option value="RQF6">RQF6/SCQF9/10</a-select-option>
                <a-select-option value="RQF7">RQF7/SCQF11</a-select-option>
                <a-select-option value="RQF8">RQF8/SCQF12</a-select-option>
                <a-select-option value="CEFRA1">CEFR A1</a-select-option>
                <a-select-option value="CEFRA2">CEFR A2</a-select-option>
                <a-select-option value="CEFRB1">CEFR B1</a-select-option>
                <a-select-option value="CEFRB2">CEFR B2</a-select-option>
                <a-select-option value="CEFRC1">CEFR C1</a-select-option>
                <a-select-option value="CEFRC2">CEFR C2</a-select-option>
                <a-select-option value="POSTGRAD">Postgraduate Doctor or Dentist</a-select-option>
                <a-select-option value="AVIATION">Aviation qualification</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
      </template>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="抵达英国日期" prop="dateOfArrival">
            <a-date-picker style="width: 100%" v-model="form.dateOfArrival" :disabled-date="beforeNow"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="离开英国日期" prop="dateOfDeparture">
            <a-date-picker style="width: 100%" v-model="form.dateOfDeparture" :disabled-date="beforeNow"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="描述旅行内容" prop="detailsForVisa">
            <a-input placeholder="例如 出席商业会议" v-model="form.detailsForVisa"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="已安排在英住宿" prop="hasAddress">
            <a-radio-group v-model="form.hasAddress">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.hasAddress === 'No'">
          <a-form-model-item label="描述住宿详情" prop="planForAddress">
            <a-input placeholder="请提供尽可能多的详细信息（如“住宿酒店”或“旅游”）" v-model="form.planForAddress"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <template v-if="form.hasAddress === 'Yes'">
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英住宿组织名称1" prop="accommodationAddressName1">
              <a-input placeholder="如果住在朋友、亲戚家里，要说出他们的全名" v-model="form.accommodationAddressName1"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英住宿地址1" prop="accommodationAddress1">
              <a-input placeholder="" v-model="form.accommodationAddress1"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英住宿城市1" prop="accommodationCity1">
              <a-input placeholder="" v-model="form.accommodationCity1"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英住宿地址邮编1" prop="accommodationZipCode1">
              <a-input v-model="form.accommodationZipCode1"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="住宿日期1" prop="accommodationDate1">
              <a-range-picker style="width: 100%" v-model="form.accommodationDate1" :disabled-date="beforeNow"
                              value-format="YYYY-MM-DD"
                              :placeholder="['入住日期', '离开日期']"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
                 v-if="!form.hasAddressRecord2 || form.hasAddressRecord2 === 'No'">
            <a-form-model-item>
              <a-icon class="dynamic-add-button" type="plus-circle" @click="addHasAddressRecord(2)"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.hasAddressRecord2 === 'Yes'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英住宿组织名称2" prop="accommodationAddressName2">
              <a-input placeholder="如果住在朋友、亲戚家里，要说出他们的全名" v-model="form.accommodationAddressName2"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英住宿地址2" prop="accommodationAddress2">
              <a-input placeholder="" v-model="form.accommodationAddress2"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英住宿城市2" prop="accommodationCity2">
              <a-input placeholder="" v-model="form.accommodationCity2"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英住宿地址邮编2" prop="accommodationZipCode2">
              <a-input v-model="form.accommodationZipCode2"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="住宿日期2" prop="accommodationDate2">
              <a-range-picker style="width: 100%" v-model="form.accommodationDate2" :disabled-date="beforeNow"
                              value-format="YYYY-MM-DD"
                              :placeholder="['入住日期', '离开日期']"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
                 v-if="!form.hasAddressRecord3 || form.hasAddressRecord3 === 'No'">
            <a-form-model-item>
              <a-icon class="dynamic-add-button" type="plus-circle" @click="addHasAddressRecord(3)"/>
              <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeHasAddressRecord(2)"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.hasAddressRecord3 === 'Yes'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英住宿组织名称3" prop="accommodationAddressName3">
              <a-input placeholder="如果住在朋友、亲戚家里，要说出他们的全名" v-model="form.accommodationAddressName2"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英住宿地址3" prop="accommodationAddress3">
              <a-input placeholder="" v-model="form.accommodationAddress3"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英住宿城市3" prop="accommodationCity3">
              <a-input placeholder="" v-model="form.accommodationCity3"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在英住宿地址邮编3" prop="accommodationZipCode3">
              <a-input v-model="form.accommodationZipCode3"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="住宿日期3" prop="accommodationDate3">
              <a-range-picker style="width: 100%" v-model="form.accommodationDate3" :disabled-date="beforeNow"
                              value-format="YYYY-MM-DD"
                              :placeholder="['入住日期', '离开日期']"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item>
              <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeHasAddressRecord(3)"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </template>

      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾到英国(10年内)" prop="hasUK">
            <a-radio-group v-model="form.hasUK">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.hasUK === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾到英国原因1" prop="beenReasonForUK1">
            <a-select placeholder="请选择" v-model="form.beenReasonForUK1">
              <a-select-option value="reasonRef_tourist">旅游(包括探亲访友)</a-select-option>
              <a-select-option value="reasonRef_business">工作</a-select-option>
              <a-select-option value="reasonRef_study">学习</a-select-option>
              <a-select-option value="reasonRef_transit">过境(在国内旅行)</a-select-option>
              <a-select-option value="reasonRef_other">其他原因</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.beenReasonForUK1 === 'reasonRef_other'">
          <a-form-model-item label="其他原因说明(访英)1" prop="descOtherReasonForUK1">
            <a-input placeholder="" v-model="form.descOtherReasonForUK1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾到英国停留时长1" prop="dateOfRecentArrivalForUK1">
            <a-range-picker style="width: 100%" v-model="form.dateOfRecentArrivalForUK1" value-format="YYYY-MM-DD"
                            :disabled-date="tenYearIn"
                            :placeholder="['抵达日期', '离开日期']" :inputReadOnly="true"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.beenReasonRecord2 || form.beenReasonRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addBeenReasonRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.hasUK === 'Yes' && form.beenReasonRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾到英国原因2" prop="beenReasonForUK2">
            <a-select placeholder="请选择" v-model="form.beenReasonForUK2">
              <a-select-option value="reasonRef_tourist">旅游(包括探亲访友)</a-select-option>
              <a-select-option value="reasonRef_business">工作</a-select-option>
              <a-select-option value="reasonRef_study">学习</a-select-option>
              <a-select-option value="reasonRef_transit">过境(在国内旅行)</a-select-option>
              <a-select-option value="reasonRef_other">其他原因</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.beenReasonForUK2 === 'reasonRef_other'">
          <a-form-model-item label="其他原因说明(访英)2" prop="descOtherReasonForUK2">
            <a-input placeholder="" v-model="form.descOtherReasonForUK2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾到英国停留时长2" prop="dateOfRecentArrivalForUK2">
            <a-range-picker style="width: 100%" v-model="form.dateOfRecentArrivalForUK2" value-format="YYYY-MM-DD"
                            :disabled-date="tenYearIn"
                            :placeholder="['抵达日期', '离开日期']" :inputReadOnly="true"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeBeenReasonRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾到欧美澳国家(10年内)" prop="hasSchengen">
            <a-radio-group v-model="form.hasSchengen">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.hasSchengen === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="欧美澳国家1" prop="arrivalSchengen1">
            <a-select v-model="form.arrivalSchengen1" placeholder="请选择">
              <a-select-option v-for="item in schengenList" :key="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="原因1" prop="beenReasonSchengen1">
            <a-select placeholder="请选择" v-model="form.beenReasonSchengen1">
              <a-select-option value="reasonRef_tourist">旅游(包括探亲访友)</a-select-option>
              <a-select-option value="reasonRef_business">工作</a-select-option>
              <a-select-option value="reasonRef_study">学习</a-select-option>
              <a-select-option value="reasonRef_transit">过境(在国内旅行)</a-select-option>
              <a-select-option value="reasonRef_other">其他原因</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.beenReasonSchengen1 === 'reasonRef_other'">
          <a-form-model-item label="其他原因说明1" prop="descOtherReasonSchengen1">
            <a-input placeholder="" v-model="form.descOtherReasonSchengen1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="停留时长1" prop="dateOfRecentArrivalSchengen1">
            <a-range-picker style="width: 100%" v-model="form.dateOfRecentArrivalSchengen1" value-format="YYYY-MM-DD"
                            :disabled-date="tenYearIn"
                            :placeholder="['抵达日期', '离开日期']" :inputReadOnly="true"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.schengenRecord2 || form.schengenRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addSchengenRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.hasSchengen === 'Yes' && form.schengenRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="欧美澳国家2" prop="arrivalSchengen2">
            <a-select v-model="form.arrivalSchengen2" placeholder="请选择">
              <a-select-option v-for="item in schengenList" :key="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="原因2" prop="beenReasonSchengen2">
            <a-select placeholder="请选择" v-model="form.beenReasonSchengen2">
              <a-select-option value="reasonRef_tourist">旅游(包括探亲访友)</a-select-option>
              <a-select-option value="reasonRef_business">工作</a-select-option>
              <a-select-option value="reasonRef_study">学习</a-select-option>
              <a-select-option value="reasonRef_transit">过境(在国内旅行)</a-select-option>
              <a-select-option value="reasonRef_other">其他原因</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.beenReasonSchengen2 === 'reasonRef_other'">
          <a-form-model-item label="其他原因说明2" prop="descOtherReasonSchengen2">
            <a-input placeholder="" v-model="form.descOtherReasonCountry2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="停留时长2" prop="dateOfRecentArrivalSchengen2">
            <a-range-picker style="width: 100%" v-model="form.dateOfRecentArrivalSchengen2" value-format="YYYY-MM-DD"
                            :disabled-date="tenYearIn"
                            :placeholder="['抵达日期', '离开日期']" :inputReadOnly="true"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeSchengenRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="其他国家/地区(10年内)" prop="hasCountry">
            <a-radio-group v-model="form.hasCountry">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.hasCountry === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="其他国家/地区" prop="arrivalCountry1">
            <a-select v-model="form.arrivalCountry1" placeholder="请选择">
              <a-select-option v-for="item in countryList" :key="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="原因1" prop="beenReasonCountry1">
            <a-select placeholder="请选择" v-model="form.beenReasonCountry1">
              <a-select-option value="reasonForVisit_tourism">旅游(包括探亲访友)</a-select-option>
              <a-select-option value="reasonForVisit_business">工作</a-select-option>
              <a-select-option value="reasonForVisit_study">学习</a-select-option>
              <a-select-option value="reasonForVisit_transit">过境(在国内旅行)</a-select-option>
              <a-select-option value="reasonForVisit_other">其他原因</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.beenReasonCountry1 === 'reasonForVisit_other'">
          <a-form-model-item label="其他原因说明1" prop="descOtherReasonCountry1">
            <a-input placeholder="" v-model="form.descOtherReasonCountry1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="停留时长1" prop="dateOfRecentArrivalCountry1">
            <a-range-picker style="width: 100%" v-model="form.dateOfRecentArrivalCountry1" value-format="YYYY-MM-DD"
                            :disabled-date="tenYearIn"
                            :placeholder="['抵达日期', '离开日期']" :inputReadOnly="true"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.countryRecord2 || form.countryRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addCountryRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.hasCountry === 'Yes' && form.countryRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾访地区2" prop="arrivalCountry2">
            <a-select v-model="form.arrivalCountry2" placeholder="请选择">
              <a-select-option v-for="item in countryList" :key="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="原因2" prop="beenReasonCountry2">
            <a-select placeholder="请选择" v-model="form.beenReasonCountry2">
              <a-select-option value="reasonForVisit_tourism">旅游(包括探亲访友)</a-select-option>
              <a-select-option value="reasonForVisit_business">工作</a-select-option>
              <a-select-option value="reasonForVisit_study">学习</a-select-option>
              <a-select-option value="reasonForVisit_transit">过境(在国内旅行)</a-select-option>
              <a-select-option value="reasonForVisit_other">其他原因</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.beenReasonCountry2 === 'reasonForVisit_other'">
          <a-form-model-item label="其他原因说明2" prop="descOtherReasonCountry2">
            <a-input placeholder="" v-model="form.descOtherReasonCountry2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="停留时长B2" prop="dateOfRecentArrivalCountry2">
            <a-range-picker style="width: 100%" v-model="form.dateOfRecentArrivalCountry2" value-format="YYYY-MM-DD"
                            :disabled-date="tenYearIn"
                            :placeholder="['抵达日期', '离开日期']" :inputReadOnly="true"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeCountryRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否有拒签记录" prop="refusedHistory">
            <a-radio-group v-model="form.refusedHistory">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.refusedHistory === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="拒签原因" prop="reasonForProblem">
            <a-select placeholder="请选择" v-model="form.reasonForProblem">
              <a-select-option value="visaRefused">签证申请被拒绝</a-select-option>
              <a-select-option value="refusedEntry">我被拒绝入境</a-select-option>
              <a-select-option value="deported">我被驱逐出境</a-select-option>
              <a-select-option value="requiredToLeave">我被要求离开</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="拒签国家/地区" prop="countryForProblem">
            <a-select v-model="form.countryForProblem" placeholder="请选择">
              <a-select-option v-for="item in refusedCountryList" :key="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="拒签日期" prop="dateForProblem">
            <a-date-picker style="width: 100%" v-model="form.dateForProblem" placeholder="请选择"
                           value-format="YYYY-MM-DD"
                           :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="拒签明细" prop="relevantInfoForProblem">
            <a-textarea placeholder="" v-model="form.relevantInfoForProblem" auto-size/>
          </a-form-model-item>
        </a-col>

      </a-row>

      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="参团出行" prop="partOfGroup">
            <a-radio-group v-model="form.partOfGroup">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.partOfGroup === 'Yes'">
          <a-form-model-item label="参团组织名" prop="groupName">
            <a-input placeholder="例如 ***旅行社" v-model="form.groupName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.partOfGroup === 'No'">
          <a-form-model-item label="其他同行人" prop="travelWithOtherPeople">
            <a-radio-group v-model="form.travelWithOtherPeople">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <template v-if="form.travelWithOtherPeople === 'Yes'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="同行人姓氏(拼音)" prop="otherPeopleSurnames">
              <a-input v-model="form.otherPeopleSurnames" placeholder="例如 li"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="同行人名字(拼音)" prop="otherPeopleGivenNames">
              <a-input v-model="form.otherPeopleGivenNames" placeholder="例如 si"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="与你的关系" prop="otherPeopleRelationShip">
              <a-select placeholder="请选择" v-model="form.otherPeopleRelationShip">
                <a-select-option value="P">父母</a-select-option>
                <a-select-option value="F">未婚妻/未婚夫</a-select-option>
                <a-select-option value="S">儿子或女儿</a-select-option>
                <a-select-option value="Fr">朋友</a-select-option>
                <a-select-option value="W">工作同事</a-select-option>
                <a-select-option value="E">雇主</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </template>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="申请的其他信息" prop="otherInformation">
            <a-textarea placeholder="如果您需要添加有关您的申请的更多信息但无法做到，您可以在此处填写。"
                        v-model="form.otherInformation" auto-size/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="偏好语言" prop="language">
            <a-select placeholder="请选择" v-model="form.language">
              <a-select-option value="Chinese">中文</a-select-option>
              <a-select-option value="English">英文</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
  </a-form-model>

</template>


<script>
import moment from "moment";
import {HttpMixins} from "@/mixins/http-mixins";

const pattern = {
  nationalIdentificationNumber: /^(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)|(^([A-Z]|[0-9]){5,17}$)$/,
  passportNumber: /^([A-Z]|[0-9]){5,17}$/,
  telephone: /^\d{10,13}$/,
  phone: /^\d{10,12}$/,
  positiveInteger: /^[1-9]\d*$/,
  english: /^[A-Za-z][A-Za-z ]*$/,
  numberOrEnglish: /^[A-Za-z0-9][A-Za-z0-9 ]*$/,
  casNumber: /^[A-Za-z0-9]{14}$/,
  mail: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
}

export default {
  name: "DetailTable",
  mixins: [HttpMixins],
  data() {
    return {
      moment,
      model: {},
      form: {},
      unitTimeList: [
        {value: 'days', text: '日'},
        {value: 'weeks', text: '周'},
        {value: 'months', text: '月'},
        {value: 'years', text: '年'},
      ],
      schengenList: [
        {value: 'countryRef_australia', text: '澳大利亚'},
        {value: 'countryRef_canada', text: '加拿大'},
        {value: 'countryRef_newzealand', text: '新西兰'},
        {value: 'countryRef_usa', text: '美国'},
        {value: 'France', text: '法国'},
        {value: 'Germany', text: '德国'},
        {value: 'Switzerland', text: '瑞士'},
        {value: 'Italy', text: '意大利'},
        {value: 'Ireland', text: '爱尔兰'},
        {value: 'Spain', text: '西班牙'},
        {value: 'Netherlands', text: '荷兰'},
      ],
      countryList: [
        {value: 'Macau', text: '澳门'},
        {value: 'Hong Kong Special Administrative Region of China', text: '香港'},
        {value: 'Taiwan', text: '台湾'},
        {value: 'Singapore', text: '新加坡'},
        {value: 'Korea, South (Republic of Korea)', text: '韩国'},
        {value: 'Japan', text: '日本'},
        {value: 'Thailand', text: '泰国'},
        {value: 'Malaysia', text: '马来西亚'},
        {value: 'Indonesia', text: '印尼'},
        {value: 'India', text: '印度'},
        {value: 'Brazil', text: '巴西'},
        {value: 'Mexico', text: '墨西哥'},
      ],

      refusedCountryList: [
        {value: 'United States of America', text: '美国'},
        {value: 'United Kingdom of Great Britain and Northern Ireland', text: '英国'},
        {value: 'France', text: '法国'},
        {value: 'Germany', text: '德国'},
        {value: 'Singapore', text: '新加坡'},
        {value: 'Japan', text: '日本'},
        {value: 'Canada', text: '加拿大'},
        {value: 'Australia', text: '澳大利亚'},
        {value: 'New Zealand', text: '新西兰'},
        {value: 'Italy', text: '意大利'},
        {value: 'Taiwan', text: '台湾'}
      ],
      rules: {
        countryCode: [{required: true, message: '必填!'}],
        otherName: [{required: true, message: '必填!'}],
        otherSurname: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        otherGivenName: [
          {required: true, pattern: pattern.english, message: '必填,英文格式!'},
          {validator: this.validOtherGivenName}
        ],
        sex: [{required: true, message: '必填!'}],
        placeOfBirth: [{required: true, message: '必填!'}],
        birthday: [{required: true, message: '必填!'}],
        relationshipStatus: [{required: true, message: '必填!'}],
        telephone: [{required: true, pattern: pattern.telephone, message: '必填,正确填写!'}],
        homeAddressForProvince: [{required: true, message: '必填!'}],
        homeAddressForCity: [{required: true, message: '必填!'}],
        homeAddressForStreet: [{required: true, message: '必填!'}],
        homeAddressForProvinced: [{required: true, message: '必填!'}],
        homeAddressForCityd: [{required: true, message: '必填!'}],
        homeAddressForStreetd: [{required: true, message: '必填!'}],
        propertyRight: [{required: true, message: '必填!'}],
        otherCategoryDetails: [{required: true, message: '必填!'}],
        rentAddressForProvince: [{required: true, message: '必填!'}],
        rentAddressForCity: [{required: true, message: '必填!'}],
        rentAddressForStreet: [{required: true, message: '必填!'}],
        dateForRent: [
          {required: true, message: '必填!'},
          {validator: this.validateDateRange}
        ],
        hasNationalIdCard: [{required: true, message: '必填!'}],
        nationalIdCard: [{required: true, pattern: pattern.nationalIdentificationNumber, message: '必填,正确填写!'}],
        issuingAuthorityForIdCard: [{required: true, message: '必填!'}],
        startDateForIdCardNo: [{required: true, message: '必填!'}],
        endDateForIdCardNo: [{}],
        issuingAuthorityForPassport: [{required: true, message: '必填!'}],
        startDateForPassport: [{required: true, message: '必填!'}],
        endDateForPassport: [{required: true, message: '必填!'}],
        fatherSurnames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        fatherGivenNames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        fatherDateOfBirth: [{required: true, message: '必填!'}],
        motherSurnames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        motherGivenNames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        motherDateOfBirth: [{required: true, message: '必填!'}],
        spouseSurnames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        spouseGivenNames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        spouseDateOfBirth: [{required: true, message: '必填!'}],
        travelWithPartner: [{required: true, message: '必填!'}],
        travelWithFather: [{required: true, message: '必填!'}],
        fatherTelephone: [{required: true, pattern: pattern.telephone, message: '必填,正确填写!'}],
        fatherEmail: [{required: true, pattern: pattern.mail, message: '输入有误,请检查!'}],
        fatherPassport: [{required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'}],
        travelWithMother: [{required: true, message: '必填!'}],
        motherTelephone: [{required: true, pattern: pattern.telephone, message: '必填,正确填写!'}],
        motherEmail: [{required: true, pattern: pattern.mail, message: '输入有误,请检查!'}],
        motherPassport: [{required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'}],

        partnerPassport: [{required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'}],
        son: [{required: true, message: '必填!'}],
        sonSurnames1: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        sonGivenNames1: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        sonDateOfBirth1: [{required: true, message: '必填!'}],
        sonRelationShip1: [{required: true, message: '必填!'}],
        travelWithSon1: [{required: true, message: '必填!'}],
        sonPassport1: [{required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'}],
        sonSurnames2: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        sonGivenNames2: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        sonDateOfBirth2: [{required: true, message: '必填!'}],
        sonRelationShip2: [{required: true, message: '必填!'}],
        travelWithSon2: [{required: true, message: '必填!'}],
        sonPassport2: [{required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'}],
        sonSurnames3: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        sonGivenNames3: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        sonDateOfBirth3: [{required: true, message: '必填!'}],
        sonRelationShip3: [{required: true, message: '必填!'}],
        travelWithSon3: [{required: true, message: '必填!'}],
        sonPassport3: [{required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'}],
        immediateRelatives: [{required: true, message: '必填!'}],

        employmentStatus: [{required: true, message: '必填!'}],
        jobContent: [{required: true, message: '必填!'}],
        jobIncome: [{required: true, message: '必填!'}],
        sponsorNumber: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        cas: [{required: true, pattern: pattern.casNumber, message: '必填,数字英文!'}],
        schoolName: [{required: true, message: '必填!'}],
        schoolType: [{required: true, message: '必填!'}],
        schoolCity: [{required: true, message: '必填!'}],
        schoolCityZipCode: [{required: true, message: '必填!'}],
        course: [{required: true, message: '必填!'}],
        courseDate: [
          {required: true, message: '必填!'},
          {validator: this.validateDateRange}
        ],
        qualification: [{required: true, message: '必填!'}],
        regularIncome: [{required: true, message: '必填!'}],
        otherIncome: [{required: true, message: '必填!'}],
        moneyInBankAmount: [{required: true, pattern: pattern.positiveInteger, message: '必填,正确填写!'}],
        incomeAmount: [{required: true, pattern: pattern.positiveInteger, message: '必填,正确填写!'}],
        hasSavings: [{required: true, message: '必填!'}],
        savingsAmount: [{required: true, pattern: pattern.positiveInteger, message: '必填,正确填写!'}],
        planeAmount: [{required: true, pattern: pattern.positiveInteger, message: '必填,正确填写!'}],
        spend: [{required: true, pattern: pattern.positiveInteger, message: '必填,正确填写!'}],
        planSpend: [{required: true, pattern: pattern.positiveInteger, message: '必填,正确填写!'}],
        costForVisit: [{required: true, message: '必填,正确填写!'}],
        costSomeoneName: [{required: true, message: '必填,正确填写!'}],
        costSomeoneTotal: [{required: true, pattern: pattern.positiveInteger, message: '必填,正确填写!'}],
        costSomeoneReason: [{required: true, message: '必填!'}],
        costSomeoneAddressForProvince: [{required: true, message: '必填!'}],
        costSomeoneAddressForCity: [{required: true, message: '必填!'}],
        costSomeoneAddressForStreet: [{required: true, message: '必填!'}],
        costCompanyTotal: [{required: true, message: '必填!'}],
        costCompanyReason: [{required: true, message: '必填!'}],
        costOtherName: [{required: true, message: '必填,正确填写!'}],
        costOtherTotal: [{required: true, pattern: pattern.positiveInteger, message: '必填,正确填写!'}],
        costOtherReason: [{required: true, message: '必填!'}],
        costOtherAddressForProvince: [{required: true, message: '必填!'}],
        costOtherAddressForCity: [{required: true, message: '必填!'}],
        costOtherAddressForStreet: [{required: true, message: '必填!'}],
        payingForYourVisit: [{required: true, message: '必填,正确填写!'}],
        hasDependants: [{required: true, message: '必填!'}],
        employer: [{required: true, message: '必填!'}],
        employerProvince: [{required: true, message: '必填!'}],
        employerCity: [{required: true, message: '必填!'}],
        employerAddress: [{required: true, message: '必填!'}],
        employerPhone: [{required: true, pattern: pattern.phone, message: '必填,正确填写!'}],
        startWorkForEmployer: [{required: true, message: '必填!'}],
        jobTitle: [{required: true, message: '必填!'}],
        jobEarn: [{required: true, message: '必填!'}],
        jobDescribe: [{required: true, message: '必填!'}],
        selfJobTitle: [{required: true, message: '必填!'}],
        selfJobEarn: [{required: true, message: '必填!'}],
        dependantRelationship: [{required: true, message: '必填!'}],
        dependantFamilyName: [{required: true, message: '必填!'}],
        dependantGivenName: [{required: true, message: '必填!'}],
        dependantBirthday: [{required: true, message: '必填!'}],
        dependantWithYou: [{required: true, message: '必填!'}],
        dependantPassport: [{required: true, message: '必填!'}],
        purposeOfVisit: [{required: true, message: '必填!'}],
        timeLived: [{required: true, pattern: pattern.positiveInteger, message: '必填!'}],
        courseFees: [{required: true, message: '必填!'}],
        reasonOfVisit: [{required: true, message: '必填!'}],
        paymentForNonPPEBusinessActivities: [{required: true, message: '必填!'}],
        detailsForVisa: [{required: true, message: '必填!'}],
        organisationsVisited: [{required: true, message: '必填!'}],
        institutionName: [{required: true, message: '必填!'}],
        courseName: [{required: true, message: '必填!'}],
        courQualification: [{required: true, message: '必填!'}],
        dateForCourse: [
          {required: true, message: '必填!'},
          {validator: this.validateDateRange}
        ],
        englishCompanyName: [{required: true, message: '必填!'}],
        englishCompanyWork: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        englishCompanyPhone: [{required: true, pattern: pattern.phone, message: '必填!'}],
        englishCompanyAddress: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        englishCompanyCity: [{required: true, pattern: pattern.english, message: '必填,英文字母!'}],
        englishCompanyZipCode: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        englishCompanyRelativesSurname: [{required: true, pattern: pattern.english, message: '必填,英文!'}],
        englishCompanyRelativesGivenName: [{required: true, pattern: pattern.english, message: '必填,英文!'}],
        hasAddress: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        planForAddress: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],

        accommodationAddressName1: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        accommodationAddress1: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        accommodationCity1: [{required: true, pattern: pattern.english, message: '必填,英文字母!'}],
        accommodationZipCode1: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        accommodationDate1: [
          {required: true, message: '必填!'},
          {validator: this.validateDateRange}
        ],
        accommodationAddressName2: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        accommodationAddress2: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        accommodationCity2: [{required: true, pattern: pattern.english, message: '必填,英文字母!'}],
        accommodationZipCode2: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        accommodationDate2: [
          {required: true, message: '必填!'},
          {validator: this.validateDateRange}
        ],
        accommodationAddressName3: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        accommodationAddress3: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        accommodationCity3: [{required: true, pattern: pattern.english, message: '必填,英文字母!'}],
        accommodationZipCode3: [{required: true, pattern: pattern.numberOrEnglish, message: '必填,数字英文!'}],
        accommodationDate3: [
          {required: true, message: '必填!'},
          {validator: this.validateDateRange}
        ],

        dateOfArrival: [{required: true, message: '必填!'}],
        dateOfDeparture: [{required: true, message: '必填!'}],
        schengenNameForOther: [{required: true, message: '必填!'}],

        hasUK: [{required: true, message: '必填!'}],
        beenReasonForUK1: [{required: true, message: '必填!'}],
        descOtherReasonForUK1: [{required: true, message: '必填!'}],
        dateOfRecentArrivalForUK1: [
          {required: true, message: '必填!'},
          {validator: this.validateDateRange}
        ],
        beenReasonForUK2: [{required: true, message: '必填!'}],
        descOtherReasonForUK2: [{required: true, message: '必填!'}],
        dateOfRecentArrivalForUK2: [
          {required: true, message: '必填!'},
          {validator: this.validateDateRange}
        ],

        refusedHistory: [{required: true, message: '必填!'}],
        reasonForProblem: [{required: true, message: '必填!'}],
        countryForProblem: [{required: true, message: '必填!'}],
        dateForProblem: [{required: true, message: '必填!'}],
        relevantInfoForProblem: [{required: true, message: '必填!'}],

        partOfGroup: [{required: true, message: '必填!'}],
        groupName: [{required: true, message: '必填!'}],
        travelWithOtherPeople: [{required: true, message: '必填!'}],
        otherPeopleSurnames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        otherPeopleGivenNames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        otherPeopleRelationShip: [{required: true, message: '必填!'}],

        hasCountry: [{required: true, message: '必填!'}],
        arrivalCountry1: [{required: true, message: '必填!'}],
        beenReasonCountry1: [{required: true, message: '必填!'}],
        descOtherReasonCountry1: [{required: true, message: '必填!'}],
        dateOfRecentArrivalCountry1: [
          {required: true, message: '必填!'},
          {validator: this.validateDateRange}
        ],
        arrivalCountry2: [{required: true, message: '必填!'}],
        beenReasonCountry2: [{required: true, message: '必填!'}],
        descOtherReasonCountry2: [{required: true, message: '必填!'}],
        dateOfRecentArrivalCountry2: [
          {required: true, message: '必填!'},
          {validator: this.validateDateRange}
        ],

        hasSchengen: [{required: true, message: '必填!'}],
        arrivalSchengen1: [{required: true, message: '必填!'}],
        beenReasonSchengen1: [{required: true, message: '必填!'}],
        descOtherReasonSchengen1: [{required: true, message: '必填!'}],
        dateOfRecentArrivalSchengen1: [
          {required: true, message: '必填!'},
          {validator: this.validateDateRange}
        ],
        arrivalSchengen2: [{required: true, message: '必填!'}],
        beenReasonSchengen2: [{required: true, message: '必填!'}],
        descOtherReasonSchengen2: [{required: true, message: '必填!'}],
        dateOfRecentArrivalSchengen2: [
          {required: true, message: '必填!'},
          {validator: this.validateDateRange}
        ],
        otherInformation: [],
        language: [{required: true, message: '必填!'}],
      },
      url: {
        draftSave: window._CONFIG['domainURL'] + "/power/ukApplicant/draftSave",
        commit: window._CONFIG['domainURL'] + "/ukApplicant/commit",
      }
    }
  },
  methods: {

    addSchengenRecord(i) {
      this.$set(this.form, ['schengenRecord' + i], 'Yes');
    },
    removeSchengenRecord(i) {
      this.$set(this.form, ['schengenRecord' + i], 'No');
    },

    addCountryRecord(i) {
      this.$set(this.form, ['countryRecord' + i], 'Yes');
    },
    removeCountryRecord(i) {
      this.$set(this.form, ['countryRecord' + i], 'No');
    },
    addHasAddressRecord(i) {
      this.$set(this.form, ['hasAddressRecord' + i], 'Yes');
    },
    removeHasAddressRecord(i) {
      this.$set(this.form, ['hasAddressRecord' + i], 'No');
    },
    validOtherGivenName(rul, value, callback) {
      if (!value) {
        callback('');
        return;
      }
      if (this.form.otherGivenName && value.toUpperCase() === this.model.givenName.toUpperCase()) {
        callback('曾用名不能现用名相同！')
        return;
      }
      callback();
    },

    validateDateRange(rul, value, callback) {
      // 没有选择日期
      if (!value || value.length !== 2) {
        callback('请选择开始和结束日期');
        return;
      }
      const [start, end] = value;
      // 判断开始日期和结束日期是否相同
      if (start === end) {
        callback('开始日期不能等于结束日期');
        return;
      }
      // 验证通过
      callback();
    },

    init(data) {
      this.$refs.targetForm.clearValidate();
      this.model = Object.assign({}, data);
      this.form = {};
      if (this.model.content) {
        this.form = JSON.parse(this.model.content);
      }
    },

    addSonRecord(i) {
      this.$set(this.form, ['sonRecord' + i], 'Yes');
    },
    removeSonRecord(i) {
      this.$set(this.form, ['sonRecord' + i], 'No');
    },
    addBeenReasonRecord(i) {
      this.$set(this.form, ['beenReasonRecord' + i], 'Yes');
    },
    removeBeenReasonRecord(i) {
      this.$set(this.form, ['beenReasonRecord' + i], 'No');
    },

    beforeExpiration(current) {
      if (this.form.issuanceDateForPassport) {
        return current < moment(this.form.issuanceDateForPassport, 'YYYY-MM-DD');
      }
    },

    afterBirthday(current) {
      if (this.form.birthday) {
        return current > moment(this.model.birthday, 'YYYY-MM-DD');
      }
    },
    beforeBirthday(current) {
      if (this.form.birthday) {
        return current < moment(this.model.birthday, 'YYYY-MM-DD');
      }
    },

    handleDraft() {
      const that = this;
      that.model.content = JSON.stringify(that.form);
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
            that.$emit('commitDraft');
          } else {
            that.$message.error(response.msg);
          }
        }
      }
      that.$axios.put(that.url.draftSave, that.model, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess));
    },
    handleValid() {
      this.$refs.targetForm.validate((valid) => {
        if (valid) {
          this.$message.success("验证通过")
          return;
        }
        this.$message.warning("验证不通过")
      })
    },
    vailBeforeSubmit(that) {
      //抵达英国日期
      if (moment(that.form.dateOfArrival, 'YYYY-MM-DD') < moment()) {
        that.$message.warning("抵达英国日期不能早于今天");
        return false
      }
      if (moment(that.form.dateOfArrival, 'YYYY-MM-DD') > moment(that.form.dateOfDeparture, 'YYYY-MM-DD')) {
        that.$message.warning("抵达英国日期不能晚于离开日期");
        return false
      }
      return true
    },
    handleSubmit() {
      const that = this;
      this.$refs.targetForm.validate((valid) => {
        if (valid && that.vailBeforeSubmit(that)) {
          that.$emit('before');
          that.model.content = JSON.stringify(that.form);
          const handleSuccess = (res) => {
            if (res) {
              let response = res.data;
              if (response.code === 200) {
                that.$emit('commit', that.model.id);
              } else {
                that.$message.error(response.msg);
              }
            }
          }
          that.$axios.put(that.url.commit, that.model, {headers: that.headers})
              .then(handleSuccess)
              .catch((error) => that.catchError(error).then(handleSuccess))
              .finally(() => that.$emit('finally'));
        } else {
          that.$message.warning("验证不通过")
        }
      })
    },
    tenYearIn(current) {
      const date = new Date()
      date.setFullYear(date.getFullYear() - 10)
      return current < moment(new Date(date)).startOf('day') || current > moment().startOf('day');
    },
    timeInRent(current) {
      const date = new Date()
      date.setFullYear(date.getFullYear() - 1)
      return current > moment(new Date(date)).startOf('month');
    },
    afterNow(current) {
      return current && current > moment().startOf('day');
    },
    beforeNow(current) {
      return current && current < moment().startOf('day');
    },
    isSameDate(current, range) {
      if (range && range.length === 1) {
        return current && current.isSame(range[0], "day")
      }
      return false
    }
  }
}
</script>

<style scoped>

.dynamic-add-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #87d068;
  transition: all 0.3s;
  margin-left: 20px;
}

.dynamic-add-button:hover {
  color: #26cc2a;
}

.dynamic-add-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 20px;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

</style>
